// 将传入参数取两位小数
export const handleToFixed2 = (num) => {
    if (num == undefined || num == "" || num == null) {
        num = "0.00";
        console.log("保留两位小数传入值为undefined或者null或者空")
        return num
    }
    if (typeof num != "string" && typeof num != "number") {
        num = "0.00";
        console.log("保留两位小数传入格式不对")
        return num
    }
    num = Number(num).toFixed(2);
    return num
}
// 复制
export const handleCopy = (content) => {

    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(content).then(()=>{
            console.log("复制成功");
            return true
        },()=>{
            console.log("复制失败");
            return false
        })
    }else{
        var ele = document.createElement("input"); //创建一个input标签
        ele.setAttribute("value", content); // 设置改input的value值
        document.body.appendChild(ele); // 将input添加到body
        ele.select();  // 获取input的文本内容
        document.execCommand("copy"); // 执行copy指令
        document.body.removeChild(ele); // 删除input标签
        return true
    }
    

}